// Money amounts: show 450,000 while typing, keep the saved value a plain number string ("450000"),
// so every existing calculation (Number(), parseFloat) keeps working.
export const moneyPlain = (value) => {
  const s = String(value ?? '').replace(/[^0-9.]/g, '');
  const [whole, ...rest] = s.split('.');
  return rest.length ? `${whole}.${rest.join('').slice(0, 2)}` : whole;
};
export const formatMoneyInput = (value) => {
  const plain = moneyPlain(value);
  if (plain === '') return '';
  const [whole, dec] = plain.split('.');
  const w = (whole || '0').replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return dec !== undefined ? `${w}.${dec}` : w;
};
